import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from "src/app/app.reducer";
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { GetCapabilityHistoryLog } from '../store/capabilities.actions';


@Component({
  selector: 'app-view-logs',
  templateUrl: './view-logs.component.html',
  styleUrls: ['./view-logs.component.scss']
})
export class ViewLogsComponent implements OnInit {
    capabilityHistoryLog: Array<any> = [];

    constructor(
        private store: Store<AppState>,
        private router: Router,
        private route: ActivatedRoute,
        public location: Location
    ) { }

    ngOnInit() {
      this.store.dispatch(new GetCapabilityHistoryLog());
      this.store.select(state => state.capabilities.capabilityLogResponse).subscribe(response => {
        console.log(response);
        if (response) {
          this.capabilityHistoryLog = response;
        }
      });
    }

}
